import $ from 'jquery';

export const ELEMENT_SELECTOR = '[data-focus-within]';
export const PLUGIN_NAME = 'FocusWithin';

$(document).ready(() => {
  $(ELEMENT_SELECTOR).each(function () {
    const element = this;
    System.import(/* webpackChunkName: "plugin--focus-within" */ './plugin')
      .then(() => {
        $(element)[PLUGIN_NAME]();
      });
  });
});



// WEBPACK FOOTER //
// ./project/client/src/core/plugins/jquery__focus-within/index.js